import React from 'react';

// CSS-based floating orbs (no three.js dependency)
export default function FloatingOrbs({ className = '' }) {
  return (
    <div className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}>
      <div className="floating-orb orb-a" />
      <div className="floating-orb orb-b" />
      <div className="floating-orb orb-c" />
      <svg className="absolute top-10 right-10 w-32 h-32 opacity-20 animate-[spin_24s_linear_infinite] hidden md:block" viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="40" stroke="#d42b92" strokeWidth="0.5" strokeDasharray="2 4" />
        <circle cx="50" cy="50" r="28" stroke="#ff5fb1" strokeWidth="0.5" strokeDasharray="1 3" />
        <circle cx="50" cy="50" r="16" stroke="#d42b92" strokeWidth="0.5" />
      </svg>
    </div>
  );
}
